













import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import { BottomTabbar } from '@/components';
import { appShare, wxShareInfo } from '@/common/ts/common';
import * as config from './config';
import { baseInfo } from './api';
@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  baseData: any = {};
  option = config.OPTHINES;
  async created() {
    const res = await baseInfo();
    this.baseData = res.data;
    this.$addPv(res.data.activityId);
    const PREFIX =
      process.env.VUE_APP_NO_CONSOLE === 'true'
        ? 'https://activity.cqcb.com/shangyou_activity/2020q2/'
        : 'https://dev.cqcb.com/';
    const FILE_PATH = '20200909CQZM/give-like';

    const SHARE_URL =
      window.location.href.indexOf('/detail?') > -1
        ? window.location.href
        : `${PREFIX}${FILE_PATH}`;

    appShare({
      title: '2020发现重庆之美邀你点赞“当评委”',
      url: SHARE_URL,
      subtitle: '点赞赢手机，每一个赞都是对TA们最好的肯定',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '2020发现重庆之美邀你点赞“当评委”',
      subtitle: '点赞赢手机，每一个赞都是对TA们最好的肯定',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
